import React from "react";
import * as S from "./ButtonsGroupStyle";

const ButtonsGroup = (props) => {
  const onForwardBtnClick = props.onForwardBtnClick;
  const onBackBtnClick = props.onBackBtnClick;

  return (
    <S.Container>
      <S.BootstrapButton color="secondary" size="lg" onClick={onBackBtnClick}>
        Tagasi
      </S.BootstrapButton>
      <S.BootstrapButton color="success" size="lg" onClick={onForwardBtnClick}>
        Edasi
      </S.BootstrapButton>
    </S.Container>
  );
};

export default ButtonsGroup;
